import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { WorkforceIndex } from '../../features/workforce/workforce-index';

export const Route = createFileRoute('/workforce/')({
  staticData: { layout: 'full-height' },
  component: WorkforcePage,
});

function WorkforcePage() {
  const partnerId = usePartnerId();
  const { t } = useTranslation('workforce');
  return partnerId ? (
    <WorkforceIndex key={partnerId} partnerId={partnerId} />
  ) : (
    <p className="p-6">{t('choosePartner')}</p>
  );
}
